exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".migrate-modal-content{color:#666666;font-weight:400}.migrate-modal-content strong{color:#333333;font-weight:600}.migrate-modal-header{display:flex;justify-content:space-between}.migrate-modal-btn a,.migrate-modal-content a{color:#338AFF;text-decoration:none}\n", ""]);

